
// Permissions needed to see records in dropdowns, possibly view.
const readPerms = [ 'show', 'list' ];

/**
 * Role permission matrix (resolved, after role layering below).
 * "full" = list/create/edit/show/delete. "read" = list/show only. "-" = no access.
 *
 * Resource          | superadmin | admin | appadmin | eventhost | user
 * ------------------|------------|-------|----------|-----------|-----
 * dashboard         | full       | full  | full     | -         | -
 * analytics         | full       | full  | full     | -         | -
 * sessions          | full       | full  | full     | read      | -
 * interviews        | read       | read  | read     | -         | -
 * form-entries      | full       | full  | full     | -         | -
 * summaries         | full       | full  | full     | -         | -
 * modules           | full       | full  | read     | -         | -
 * users             | full       | full  | -        | -         | -
 * ip-access         | full       | full  | -        | -         | -
 * personas          | full       | read  | -        | -         | -
 * voices            | full       | read  | -        | -         | -
 * prompt-versions   | full       | full  | -        | -         | -
 * groups            | full       | full  | -        | -         | -
 * prompt-templates  | full       | -     | -        | -         | -
 * prompt-preview    | read       | -     | -        | -         | -
 *
 * `user` has no admin-panel permissions at all — it's the default role for
 * anyone who only needs to log in and use the kiosk. It's what `eventhost`
 * amounts to today in practice; `eventhost` is kept as a distinct role in
 * case it grows real permissions later.
 *
 * `modules: readPerms` on appAdminRoles is required for the Session edit form's
 * module picker (Sessions now embed a list of Module associations) to be able to
 * list Modules for anyone who can edit a Session, without granting Module/prompt
 * editing rights below the admin level. prompt-templates/prompt-preview stay
 * superadmin-only per the deliberate tightening in `ec3b520`.
 */

const appAdminRoles = {
	dashboard: true,
	analytics: true,
	sessions: true,
	interviews: readPerms,
	'form-entries': true,
	summaries: true,
	modules: readPerms
}

const adminRoles = {
	users: true,
	'ip-access': true,
	personas: readPerms,
	voices: readPerms,
	modules: true,
	'prompt-versions': true,
	groups: true
};

const superAdminRoles = {
	personas: true,
	voices: true,

	groups: true,
	modules: true,
	'prompt-templates': true,
	'prompt-versions': true,
	'prompt-preview': readPerms
}

const Roles = {
	superadmin: {
		name: 'Super Admin',
		permissions: {
			...appAdminRoles,
			...adminRoles,
			...superAdminRoles
		}
	},
	admin: {
		name: 'Admin',
		permissions: {
			...appAdminRoles,
			...adminRoles
		}
	},

	appadmin: {
		name: 'App Admin',
		permissions: {
			...appAdminRoles
		}
	},

	eventhost: {
		name: 'Event Manager',
		permissions: {
			sessions: readPerms
		}
	},

	user: {
		name: 'User',
		permissions: {}
	}
};

const makeRoleChoices = () => {
	const choices = [];
	for ( const id in Roles ) {
		const { name } = Roles[id];
		choices.push( { id, name } );
	}

	return choices;
}

const expandPermissions = ( perm ) => {
	const permissions = {};
	const allActions = [ 'list', 'create', 'edit', 'show', 'delete' ]; //update?

	for ( const resource in perm ) {
		const actions = perm[resource] === true ? allActions : perm[resource];
		if ( actions ) {
			permissions[resource] = actions;
		}
	}

	return permissions;
};

const RoleChoices = makeRoleChoices()

// @todo: Future optimization for multiple roles
const permissionsByRole = ( roles ) => {

	if ( ! Array.isArray( roles ) ) {
		roles = [ roles ];
	}

	const combinedRoles = {};

	for ( const role of roles ) {
		if ( role in Roles ) {
			Object.assign( combinedRoles, Roles[role].permissions );
		}
	}

	return expandPermissions( combinedRoles );
};

const roleCan = ( role, resource, action ) => {
	const perm = permissionsByRole( role );
	let success = false;

	if ( resource in perm ) {
		success = perm[resource].includes( action );
	}
	
	console.log( role, resource, action, success );

	return success;
};

module.exports = {
	permissionsByRole,
	RoleChoices,
	expandPermissions,
	makeRoleChoices,
	roleCan
};
